import { useMemo } from 'react'

const normalizeValue = value => {
	if (value == null) return ''
	const text = String(value).trim()
	return text
}

const useAcademicPerformance = ({ data }) => {
	const {
		grades,
		academicAchievements,
		sat,
		act,
		englishTestScore,
		otherTestScore,
	} = data || {}

	const achievementsList = useMemo(() => {
		if (!academicAchievements) return []
		return academicAchievements
			.split(',')
			.map(item => item.trim())
			.filter(Boolean)
	}, [academicAchievements])

	const stats = useMemo(
		() => [
			{ label: 'GPA', value: normalizeValue(grades) },
			{ label: 'SAT', value: normalizeValue(sat) },
			{ label: 'ACT', value: normalizeValue(act) },
			{
				label: 'IELTS',
				value: normalizeValue(englishTestScore || otherTestScore),
			},
		],
		[grades, sat, act, englishTestScore, otherTestScore]
	)

	const hasAnyStat = stats.some(stat => stat.value !== '')

	return {
		grades,
		achievementsList,
		stats,
		hasAnyStat,
	}
}

export default useAcademicPerformance
